import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { combineLatest } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { AuthService } from '../../services/auth.service';
import { CommonService } from '../../services/common.service';
import { CashInOutDialogService } from '../../services/cash-in-out-dialog.service';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitem, RouterModule],
  template: `<ul class="layout-menu">
    <li *ngIf="isMenuLoading" class="px-3 py-2 text-muted-color">Loading menu...</li>
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu {

  authService = inject(AuthService);
  commonService = inject(CommonService);
  private cashInOutDialog = inject(CashInOutDialogService);
  isMenuLoading = true;
  model: MenuItem[] = [];
  menu: MenuItem[] = [
    {
      label: 'Home',
      items: [
        { code: 'dash', label: 'Dashboard', icon: 'pi pi-fw pi-home', AllowedRoles: [1, 2, 3], routerLink: ['/'] },
        {
          code: 'cash', label: 'Cashier', icon: 'pi pi-fw pi-wallet', AllowedRoles: [1, 2, 3],
          items: [
            { code: 'cash-reg', label: 'Cash Register', icon: 'pi pi-fw pi-calculator', AllowedRoles: [1, 2, 3], routerLink: ['/pages/cashier/cash-register'] },
            {
              code: 'cash-in',
              label: 'Cash In',
              icon: 'pi pi-fw pi-arrow-down',
              AllowedRoles: [1, 2, 3],
              url: '#',
              command: (e) => {
                e.originalEvent?.preventDefault();
                this.cashInOutDialog.openCashIn();
              }
            },
            {
              code: 'cash-out',
              label: 'Cash Out',
              icon: 'pi pi-fw pi-arrow-up',
              AllowedRoles: [1, 2, 3],
              url: '#',
              command: (e) => {
                e.originalEvent?.preventDefault();
                this.cashInOutDialog.openCashOut();
              }
            },
            { code: 'cash-log', label: 'Cash Logs', icon: 'pi pi-fw pi-list', AllowedRoles: [1, 2, 3], routerLink: ['/pages/cashier/cash-logs'] }
          ]
        },
        { code: 'enq-lst', label: 'Enquiry', icon: 'pi pi-fw pi-inbox', AllowedRoles: [1, 2, 3], routerLink: ['/pages/enquiry'] },
        { code: 'payslips', label: 'My Payslip', icon: 'pi pi-fw pi-wallet', AllowedRoles: [2, 3], routerLink: ['/pages/employee/emp-payslips'] },
        { code: 'my-expenses', label: 'My Expenses', icon: 'pi pi-fw pi-car', AllowedRoles: [1, 2, 3], routerLink: ['/pages/employee/my-expenses'] },
        { code: 'my-advances', label: 'My Advances', icon: 'pi pi-fw pi-wallet', AllowedRoles: [1, 2, 3], routerLink: ['/pages/employee/my-advances'] },
        {
          code: 'job', label: 'Job', icon: 'pi pi-fw pi-users', AllowedRoles: [1, 2, 3],
          items: [
            { code: 'job-lst', label: 'Job List', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/jobs'] },
            { code: 'job-lst', label: 'Job Followup List', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/jobs/followups'] },
            { code: 'job-new', label: 'Add new', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/jobs/add'] },
          ]
        },
        {
          code: 'supp', label: 'Suppliers', icon: 'pi pi-fw pi-users', AllowedRoles: [1, 2, 3],
          items: [
            { code: 'cus-lst', label: 'Customers', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/customers-list'] },
            { code: 'dis-lst', label: 'Distributors/Vendors', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/distributors-list'] },
          ]
        },
        {
          code: 'emp', label: 'Employee', icon: 'pi pi-fw pi-users', AllowedRoles: [1],
          items: [
            { code: 'emp-lst', label: 'Employee List', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/employee/emp-list'] },
            { code: 'emp-att', label: 'Employee Attendance', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/employee/emp-attendance'] },
            { code: 'emp-leave', label: 'Leave Requests', icon: 'pi pi-fw pi-calendar-minus', AllowedRoles: [1], routerLink: ['/pages/employee/leave-requests'] },
            { code: 'emp-expense', label: 'Expense Claims', icon: 'pi pi-fw pi-car', AllowedRoles: [1], routerLink: ['/pages/employee/expense-claims'] },
            { code: 'emp-advance', label: 'Advance Requests', icon: 'pi pi-fw pi-wallet', AllowedRoles: [1], routerLink: ['/pages/employee/advance-requests'] },
            { code: 'holdys', label: 'Holidays', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/employee/comp-holiday-list'] },
            { code: 'payslips', label: 'Payslips', icon: 'pi pi-fw pi-wallet', AllowedRoles: [1], routerLink: ['/pages/employee/emp-payslips'] },
            { code: 'gnrpayslips', label: 'Generate Payslip', icon: 'pi pi-fw pi-file-edit', AllowedRoles: [1], routerLink: ['/pages/employee/emp-generate-payslip'] },
          ]
        },
        {
          code: 'store', label: 'Store', icon: 'pi pi-fw pi-users', AllowedRoles: [1, 2, 3],
          items: [
            { code: 'store-lst', label: 'Store Item List', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/store-item/store-item-list'] },
            { code: 'store-itm-bill-lst', label: 'Store Item Bill List', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/store-item/store-item-bill-list'] },
          ]
        },
        {
          code: 'inv', label: 'Invoice', icon: 'pi pi-fw pi-users', AllowedRoles: [1, 2, 3],
          items: [
            { code: 'inv-lst', label: 'Invoice List', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/invoice'] },
            { code: 'inv-add', label: 'Add New Invoice', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/invoice/add'] },
            { code: 'inv-add-rs', label: 'Add New ReSale Invoice', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/invoice/add-rs'] },
            { code: 'inv-itm-lst', label: 'Invoice Item List', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/invoice-item/invoice-item-list'] },
          ]
        },
        {
          code: 'bill', label: 'Purchase Bill', icon: 'pi pi-fw pi-users', AllowedRoles: [1, 2, 3],
          items: [
            { code: 'bill-lst', label: 'Purchase Bill List', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/bill'] },
            { code: 'bill-add', label: 'New Store Item Bill', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/bill/add'] },
            { code: 'bill-add-rs', label: 'New Store Item resale Bill', icon: 'pi pi-fw pi-user', AllowedRoles: [1, 2, 3], routerLink: ['/pages/bill/add-rs'] },
          ]
        },
        {
          code: 'credit', label: 'Credit', icon: 'pi pi-fw pi-money-bill', AllowedRoles: [1, 2, 3],
          items: [
            { code: 'credit-pay-col', label: 'Payment Collection', icon: 'pi pi-fw pi-wallet', AllowedRoles: [1, 2, 3], routerLink: ['/pages/credit/payment-collection'] },
            { code: 'credit-pay-hist', label: 'Payment History', icon: 'pi pi-fw pi-history', AllowedRoles: [1, 2, 3], routerLink: ['/pages/credit/payment-history'] },
            { code: 'credit-notes', label: 'Credit/Debit Notes', icon: 'pi pi-fw pi-file-edit', AllowedRoles: [1, 2, 3], routerLink: ['/pages/credit/credit-notes'] },
            { code: 'credit-cheques', label: 'Cheque Register', icon: 'pi pi-fw pi-book', AllowedRoles: [1, 2, 3], routerLink: ['/pages/credit/cheques'] },
          ]
        },
        {
          code: 'rpt', label: 'Reports', icon: 'pi pi-fw pi-users', AllowedRoles: [1],
          items: [
            { code: 'rpt-jb-cld', label: 'Job Closed', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/report/job-closed'] },
            { code: 'rpt-jb-adv', label: 'Jobs Advance Search', icon: 'pi pi-fw pi-search', AllowedRoles: [1], routerLink: ['/pages/report/jobs-advance-search'] },
            { code: 'rpt-cr-out', label: 'Outstanding', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/report/outstanding'] },
            { code: 'rpt-cr-age', label: 'Aging', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/report/aging'] },
            { code: 'rpt-cr-overdue', label: 'Overdue Payments', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/report/overdue-payments'] },
            { code: 'rpt-cr-util', label: 'Credit Limit Utilization', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/report/credit-limit-utilization'] },
            { code: 'rpt-cr-pend', label: 'Pending Invoices', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/report/pending-invoices'] },
            { code: 'rpt-cr-coll', label: 'Payment Collection Report', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/report/payment-collection'] },
            { code: 'rpt-cr-summ', label: 'Collection Summary', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/report/collection-summary'] },
            { code: 'rpt-cr-ledger', label: 'Party Ledger / Statement', icon: 'pi pi-fw pi-user', AllowedRoles: [1], routerLink: ['/pages/report/party-ledger'] },
          ]
        },
        { code: 'settings', label: 'Settings', icon: 'pi pi-fw pi-cog', AllowedRoles: [1], routerLink: ['/pages/settings'] }
      ]
    }
  ];

  ngOnInit() {
    combineLatest([
      this.authService.currentUser,
      this.commonService.menuCodesLoaded$,
      this.commonService.clientContextRevision$
    ])
      .subscribe(([user, menuCodesLoaded]) => {
        this.isMenuLoading = !!user && !menuCodesLoaded;

        if (!!user && user.userRoleId != null && menuCodesLoaded) {
          this.model = this.getMenuItems(Number(user.userRoleId));
          this.isMenuLoading = false;
        }
      });
  }    // this.model = [
    //     {
    //         label: 'Home',
    //         items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/'] }]
    //     },
    //     {
    //         label: 'UI Components',
    //         items: [
    //             { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'] },
    //             { label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'] },
    //             { label: 'Button', icon: 'pi pi-fw pi-mobile', class: 'rotated-icon', routerLink: ['/uikit/button'] },
    //             { label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'] },
    //             { label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list'] },
    //             { label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree'] },
    //             { label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel'] },
    //             { label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay'] },
    //             { label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media'] },
    //             { label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'] },
    //             { label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message'] },
    //             { label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file'] },
    //             { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts'] },
    //             { label: 'Timeline', icon: 'pi pi-fw pi-calendar', routerLink: ['/uikit/timeline'] },
    //             { label: 'Misc', icon: 'pi pi-fw pi-circle', routerLink: ['/uikit/misc'] }
    //         ]
    //     },
    //     {
    //         label: 'Pages',
    //         icon: 'pi pi-fw pi-briefcase',
    //         routerLink: ['/pages'],
    //         items: [
    //             {
    //                 label: 'Landing',
    //                 icon: 'pi pi-fw pi-globe',
    //                 routerLink: ['/landing']
    //             },
    //             {
    //                 label: 'Auth',
    //                 icon: 'pi pi-fw pi-user',
    //                 items: [
    //                     {
    //                         label: 'Login',
    //                         icon: 'pi pi-fw pi-sign-in',
    //                         routerLink: ['/auth/login']
    //                     },
    //                     {
    //                         label: 'Error',
    //                         icon: 'pi pi-fw pi-times-circle',
    //                         routerLink: ['/auth/error']
    //                     },
    //                     {
    //                         label: 'Access Denied',
    //                         icon: 'pi pi-fw pi-lock',
    //                         routerLink: ['/auth/access']
    //                     }
    //                 ]
    //             },
    //             {
    //                 label: 'Crud',
    //                 icon: 'pi pi-fw pi-pencil',
    //                 routerLink: ['/pages/crud']
    //             },
    //             {
    //                 label: 'Not Found',
    //                 icon: 'pi pi-fw pi-exclamation-circle',
    //                 routerLink: ['/pages/notfound']
    //             },
    //             {
    //                 label: 'Empty',
    //                 icon: 'pi pi-fw pi-circle-off',
    //                 routerLink: ['/pages/empty']
    //             }
    //         ]
    //     },
    //     {
    //         label: 'Hierarchy',
    //         items: [
    //             {
    //                 label: 'Submenu 1',
    //                 icon: 'pi pi-fw pi-bookmark',
    //                 items: [
    //                     {
    //                         label: 'Submenu 1.1',
    //                         icon: 'pi pi-fw pi-bookmark',
    //                         items: [
    //                             { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-bookmark' },
    //                             { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-bookmark' },
    //                             { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-bookmark' }
    //                         ]
    //                     },
    //                     {
    //                         label: 'Submenu 1.2',
    //                         icon: 'pi pi-fw pi-bookmark',
    //                         items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-bookmark' }]
    //                     }
    //                 ]
    //             },
    //             {
    //                 label: 'Submenu 2',
    //                 icon: 'pi pi-fw pi-bookmark',
    //                 items: [
    //                     {
    //                         label: 'Submenu 2.1',
    //                         icon: 'pi pi-fw pi-bookmark',
    //                         items: [
    //                             { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-bookmark' },
    //                             { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-bookmark' }
    //                         ]
    //                     },
    //                     {
    //                         label: 'Submenu 2.2',
    //                         icon: 'pi pi-fw pi-bookmark',
    //                         items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-bookmark' }]
    //                     }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         label: 'Get Started',
    //         items: [
    //             {
    //                 label: 'Documentation',
    //                 icon: 'pi pi-fw pi-book',
    //                 routerLink: ['/documentation']
    //             },
    //             {
    //                 label: 'View Source',
    //                 icon: 'pi pi-fw pi-github',
    //                 url: 'https://github.com/primefaces/sakai-ng',
    //                 target: '_blank'
    //             }
    //         ]
    //     }
    // ];

  private getMenuItems(currentRole: number) {
    const roleId = Number(currentRole);
    return this.menu
      .map(menu => {
        const filteredItems = (menu.items || [])
          .filter(item => this.isMenuItemAllowed(item, roleId))
          .map(item => ({
            ...item,
            items: item.items
              ? item.items.filter((subItem: any) => this.isMenuItemAllowed(subItem, roleId))
              : undefined
          }));

        return { ...menu, items: filteredItems };
      })
      .filter(menu => menu.items && menu.items.length > 0);
  }

  private isMenuItemAllowed(item: any, currentRole: number): boolean {
    const roleAllowed = item['AllowedRoles']?.some((role: number) => Number(role) === currentRole);
    if (!roleAllowed) {
      return false;
    }

    // Employee self-service payslip — always show for staff roles
    if (item['code'] === 'payslips' && [2, 3].includes(currentRole)) {
      return true;
    }

    return this.commonService.menuCodes?.some(code => code.value === item['code']) ?? false;
  }

}
